import { render, staticRenderFns } from "./SDeleteDialog.vue?vue&type=template&id=69132f85&"
import script from "./SDeleteDialog.vue?vue&type=script&lang=js&"
export * from "./SDeleteDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports